"use client";

import { useEffect, useState } from "react";
import Modal from "react-modal";

const ClientOnlyEffects = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    Modal.setAppElement(document.body); // Safe, runs only on client
    setIsOpen(true);
  }, []);

  useEffect(() => {
    import("../../../public/assets/purecounter_vanilla").then((module) => {
      const PureCounter = module.default || module;
      new PureCounter();
    });
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/assets/tawk_to.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

      const handleContactClick = () => {
        setIsOpen(false); // Close modal
      
        setTimeout(() => {
          const contactSection = document.getElementById("contact-us");
          const headerOffset = 210; // <-- Adjust this to your header height in pixels
      
          if (contactSection) {
            const elementPosition = contactSection.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - headerOffset;
      
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }
        }, 300);
      };

  return (
    <>
       <Modal
          isOpen={isOpen}
          onRequestClose={() => setIsOpen(false)}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay to highlight modal
              zIndex: 1000, // Ensures modal is on top
            },
            content: {
              width: "50%",
              margin: "auto",
              padding: "20px",
              borderRadius: "10px",
              textAlign: "center",
              position: "relative", // Keeps modal stable
              zIndex: 1001, // Higher than overlay
            },
          }}
        >
          <button className="modal-close-btn" onClick={() => setIsOpen(false)}>×</button>

          <h2 className="modal-h2">Special Offer!</h2>
          <p className="modal-text">Get 30% off on your first purchase.</p>

          <button className="modal-btn" onClick={handleContactClick}>
            Contact Us
          </button>
        </Modal>
    </>
  );
};

export default ClientOnlyEffects;
